import React, { SVGProps } from 'react'

export const DumbbellSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      d="M2 6.148C2 5.514 2.404 5 2.902 5h5.196C8.596 5 9 5.514 9 6.148V10.5h6V6.148c0-.634.404-1.148.902-1.148h5.196c.498 0 .902.514.902 1.148v3.893c.576.138 1 .606 1 1.161v1.596c0 .555-.424 1.023-1 1.16v3.894c0 .634-.404 1.148-.902 1.148h-5.196c-.498 0-.902-.514-.902-1.148V13.5H9v4.352C9 18.486 8.596 19 8.098 19H2.902C2.404 19 2 18.486 2 17.852V13.96c-.576-.138-1-.606-1-1.161v-1.596c0-.555.424-1.023 1-1.16V6.147Z"
    />
  </svg>
)
